const app = "authen"; //应用名称，用于多套部署cookie隔离

import API from "./apiconfig.js"; 

import MD5 from "./md5.js";
//---------------------------------
var layui = window.layui;




//by函数接受一个成员名字符串和一个可选的次要比较函数做为参数
//并返回一个可以用来包含该成员的对象数组进行排序的比较函数
//当o[age] 和 p[age] 相等时，次要比较函数被用来决出高下
var by = function(name, minor) {
    return function(o, p) {
        var a, b;
        if (o && p && typeof o === 'object' && typeof p === 'object') {
            a = o[name];
            b = p[name];
            if (a === b) {
                return typeof minor === 'function' ? minor(o, p) : 0;
            }
            if (typeof a === typeof b) {
                return a < b ? -1 : 1;
            }
            return typeof a < typeof b ? -1 : 1;
        } else {
            thro("error");
        }
    }
};









import $ from 'jquery'
//---------------------------------
//let httpArr = [];  //判断到登录无效时，后续请求进等待队列，避免多次弹出未登录

import Constant from './constant.js'

const common = {
    //attribute......
    App: app,
    User: {
        Token: function(val) {
            if (!val) {
                //获取值
                var user = layui.data(app + 'User');
                return user.Token;
            } else {
                if (val == null) {
                    //删除值
                    layui.data(app + 'User', {
                        key: 'Token',
                        remove: true
                    });
                } else {
                    //设置值
                    layui.data(app + 'User', {
                        key: 'Token',
                        value: val
                    });
                }
                return true;
            }
        },
        //基本信息
        Info: function(val) {
            if (!val) {
                //获取值
                var user = layui.data(app + 'User');
                return user.Info;
            } else {
                if (val == null) {
                    //删除值
                    layui.data(app + 'User', {
                        key: 'Info',
                        remove: true
                    });
                } else {
                    //设置值
                    layui.data(app + 'User', {
                        key: 'Info',
                        value: val
                    });
                }
                return true;
            }
        },
        //部门权限
        DeptPms: function(val) {
            if (!val) {
                //获取值
                var user = layui.data(app + 'User');
                return user.DeptPms;
            } else {
                if (val == null) {
                    //删除值
                    layui.data(app + 'User', {
                        key: 'DeptPms',
                        remove: true
                    });
                } else {
                    //设置值
                    layui.data(app + 'User', {
                        key: 'DeptPms',
                        value: val
                    });
                }
                return true;
            }
        }, 
        //功能权限
        RolePms: function(val) {
            if (!val) {
                //获取值
                var user = layui.data(app + 'User');
                return user.RolePms;
            } else {
                if (val == null) {
                    //删除值
                    layui.data(app + 'User', {
                        key: 'RolePms',
                        remove: true
                    });
                } else {
                    //设置值
                    layui.data(app + 'User', {
                        key: 'RolePms',
                        value: val
                    });
                }
                return true;
            }
        }

    },
    Data: { 
        Storage: function(key, val) {
            if (!val) {
                //获取值
                var stor = layui.data(app + 'Storage');
                return stor[key];
            } else {
                if (val == null) {
                    //删除值
                    layui.data(app + 'Storage', {
                        key: key,
                        remove: true
                    });
                } else {
                    //设置值
                    layui.data(app + 'Storage', {
                        key: key,
                        value: val
                    });
                }
                return true;
            }
        }

    },
    //method......
    Get2: function(url, data, callFunc) {
        // if (API)
        // {
        //     console.log(API);
        // }

        let JsonObj = { "Code": "-2", "Data": "{}", "Msg": "请求超时" };
        $.ajax({
            type: "get",
            async: false,
            url: API.apiBase + url + "?&" + data,
            dataType: "json",
            headers: {
                "token": common.User.Token()
            },
            //jsonp: "callback", //传递给请求处理程序或页面的，用以获得jsonp回调函数名的参数名(一般默认为:callback)
            //jsonpCallback:"?",//自定义的jsonp回调函数名称，默认为jQuery自动生成的随机函数名，也可以写"?"，jQuery会自动为你处理数据
            success: function(res) {
                callFunc(res);
            },
            error: function(XMLHttpRequest, textStatus, errorThrown, data) {
                //alert("请求出错：" + errorThrown);
                console.log(XMLHttpRequest + textStatus + errorThrown + data);
                JsonObj = { "Code": "-3", "Data": "{}", "Msg": "请求出错" };
                callFunc(JsonObj);
            }
        });

    },

    //GET通用顶级获取数据方法
    Get: function(url, data, callFunc) {
         
        let JsonObj = { "Code": "-2", "Data": "{}", "Msg": "请求超时" };

        var api = API.apiBase;
        if (url.indexOf("http") >= 0) {
            api = "";
        }
        var newUrl = "";
        if (url.indexOf("/") == 0) {
            newUrl = api + url;
        } else {
            if (api != "") {
                newUrl = api + "/" + url;
            } else {
                newUrl = url;
            }
        }

        if (newUrl.indexOf("#") < 0) {
            newUrl += "#";
        }
        var ul = newUrl.substring(0, newUrl.indexOf("#"));
        if (ul.indexOf("?") > 0) {
            ul += "&";
        } else {
            ul += "?";
        }
        ul += "";

        $.ajax({
            type: "get",
            async: false,
            url: ul + data,
            dataType: "json",
            headers: {
                "accessToken": common.User.Token()
            },
            //jsonp: "callback", //传递给请求处理程序或页面的，用以获得jsonp回调函数名的参数名(一般默认为:callback)
            //jsonpCallback:"?",//自定义的jsonp回调函数名称，默认为jQuery自动生成的随机函数名，也可以写"?"，jQuery会自动为你处理数据
            success: function(res) {
                callFunc(res);
            },
            error: function(XMLHttpRequest, textStatus, errorThrown, data) {
                //alert("请求出错：" + errorThrown);
                console.log(XMLHttpRequest + textStatus + errorThrown + data);
                JsonObj = { "Code": "-3", "Data": "{}", "Msg": "请求出错" };
                callFunc(JsonObj);
            }
        });
    },
    ////--添、删、改 提交数据-- data为json字符串 
    Submit: function(url, data, callFunc) {
        let JsonObj = { "Code": "-2", "Data": "{}", "Msg": "请求超时" };
        var api = API.apiBase;
        if (url.indexOf("http") >= 0) {
            api = "";
        }
        var newUrl = "";
        if (url.indexOf("/") == 0) {
            newUrl = api + url;
        } else {
            if (api != "") {
                newUrl = api + "/" + url;
            } else {
                newUrl = url;
            }
        }

        if (newUrl.indexOf("#") < 0) {
            newUrl += "#";
        }
        var ul = newUrl.substring(0, newUrl.indexOf("#"));
        if (ul.indexOf("?") > 0) {
            ul += "&";
        } else {
            ul += "?";
        }
        ul += "";
        $.ajax({
            type: "post",
            async: false,
            url: ul,
            data: data,
            headers: {
                "accessToken": common.User.Token()
            },
            contentType: 'application/json;charset=utf-8',
            //contentType: 'application/json',
            dataType: 'json',
            success: function(res) { 
                if (res != undefined && res != "undefined" && res != null) {
                    if (typeof(res) == "string") {
                        JsonObj = JSON.parse(res);
                        // console.log("字符串");
                    } else {
                        JsonObj = res;
                        // console.log("对象");
                    }
                }
                if ([Constant.RES_CODE.ERROR_1, Constant.RES_CODE.ERROR_2, Constant.RES_CODE.ERROR_3].indexOf(JsonObj.errorCode) >= 0) {
                    common.CheckLogin(0);
                    return;
                } else if (JsonObj.errorCode == Constant.RES_CODE.ERROR_6) {
                    console.log(JsonObj) 
                    location.href = "/#/authen/error/403?api=" + url;
                    return;

                } else {
                    callFunc(JsonObj);
                }
            },
            error: function(XMLHttpRequest, textStatus, errorThrown, data) {
                //alert("请求出错：" + errorThrown);
                console.log(XMLHttpRequest + errorThrown + textStatus + data);
                JsonObj = { "Code": "-3", "Data": "{}", "Msg": "请求出错" };
                callFunc(JsonObj);
            }
        });
    },
    //-----获取数据-------------
    GetList: function(url, data, callFunc) {
        let JsonObj = { "Code": "-2", "Data": "{}", "Msg": "请求超时" };

        var api = API.apiBase;
        if (url.indexOf("http") >= 0) {
            api = "";
        }
        var newUrl = "";
        if (url.indexOf("/") == 0) {
            newUrl = api + url;
        } else {
            if (api != "") {
                newUrl = api + "/" + url;
            } else {
                newUrl = url;
            }
        }
        if (newUrl.indexOf("#") < 0) {
            newUrl += "#";
        }
        var ul = newUrl.substring(0, newUrl.indexOf("#"));
        if (ul.indexOf("?") > 0) {
            ul += "&";
        } else {
            ul += "?";
        }
        ul += "";
        $.ajax({
            type: "post",
            async: false,
            url: ul,
            data: data,
            headers: {
                "accessToken": common.User.Token()
            },
            success: function(res) {
                if (res != undefined && res != "undefined" && res != null) {
                    if (typeof(res) == "string") {
                        JsonObj = JSON.parse(res);
                        // console.log("字符串");
                    } else {
                        JsonObj = res;
                        //console.log("对象");
                    }
                }

                if ([Constant.RES_CODE.ERROR_1, Constant.RES_CODE.ERROR_2, Constant.RES_CODE.ERROR_3].indexOf(JsonObj.errorCode) >= 0) {
                    console.log(JsonObj)
                    common.CheckLogin(1);
                } else if (JsonObj.errorCode == Constant.RES_CODE.ERROR_6) {
                    console.log(JsonObj);
                    location.href = "/#/authen/error/403?api=" + url;
                    return;
                } else {
                    callFunc(JsonObj);
                }
            },
            error: function(XMLHttpRequest, textStatus, errorThrown, data) {
                //alert("请求出错："+errorThrown);
                console.log(XMLHttpRequest + errorThrown + textStatus + data);
                JsonObj = { "Code": "-3", "Data": "{}", "Msg": "请求出错" };
                callFunc(JsonObj);
            }
        });



        //alert(obj);
        //return obj;
    },
    //Content-Type:application/x-www-form-urlencoded; charset=UTF-8
    GetList2: function(url, data, callFunc) {
        let JsonObj = { "Code": "-2", "Data": "{}", "Msg": "请求超时" };

        var api = API.apiBase;
        if (url.indexOf("http") >= 0) {
            api = "";
        }
        var newUrl = "";
        if (url.indexOf("/") == 0) {
            newUrl = api + url;
        } else {
            if (api != "") {
                newUrl = api + "/" + url;
            } else {
                newUrl = url;
            }
        }
        if (newUrl.indexOf("#") < 0) {
            newUrl += "#";
        }
        var ul = newUrl.substring(0, newUrl.indexOf("#"));
        if (ul.indexOf("?") > 0) {
            ul += "&";
        } else {
            ul += "?";
        }
        ul += "";
        $.ajax({
            type: "post",
            async: false,
            url: ul,
            data: data,
            headers: {
                "accessToken": common.User.Token()
            },
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            success: function(res) {
                if (res != undefined && res != "undefined" && res != null) {
                    if (typeof(res) == "string") {
                        JsonObj = JSON.parse(res);
                        // console.log("字符串");
                    } else {
                        JsonObj = res;
                        //console.log("对象");
                    }
                }

                if ([Constant.RES_CODE.ERROR_1, Constant.RES_CODE.ERROR_2, Constant.RES_CODE.ERROR_3].indexOf(JsonObj.errorCode) >= 0) {
                    console.log(JsonObj);
                    common.CheckLogin(1);
                } else if (JsonObj.errorCode == Constant.RES_CODE.ERROR_6) {
                    console.log(JsonObj);
                    location.href = "/#/authen/error/403?api=" + url;
                    return;
                } else {
                    callFunc(JsonObj);
                }
            },
            error: function(XMLHttpRequest, textStatus, errorThrown, data) {
                //alert("请求出错："+errorThrown);
                console.log(XMLHttpRequest + errorThrown + textStatus + data);
                JsonObj = { "Code": "-3", "Data": "{}", "Msg": "请求出错" };
                callFunc(JsonObj);
            }
        });



        //alert(obj);
        //return obj;
    }, 
    CheckLogin: () => {
        setTimeout(() => {
            layui.use('layer', function() {
                var layer = layui.layer;
                layer.closeAll();

                top.location.href = '/#/authen/login';
            });
            
 
        }, 1000);
    },

    OpenDom: function(domstr, title, area, otherObj) {
        let layerObj = null;
        layui.use('layer', function() {
            var layer = layui.layer;


            let w = 'auto';
            let h = '500px';
            if (!area) {
                area = [w, h];
            } else {
                if (area[1] == "auto") {
                    area[1] = '500px';
                }
                if (area[1].indexOf("%") >= 0) {
                    area[1] = '500px';
                }
                if (parseInt(area[1].replace("px", "")) >= document.documentElement.clientHeight - 60 * 2) {
                    area[1] = '500px';
                }
            }
            if (parseInt(area[1].replace("px", "")) >= document.documentElement.clientHeight - 60 * 2) {
                area[1] = (document.documentElement.clientHeight - 60 * 2 - 10) * 1 + 'px';
            }

            let id = "opendom_" + MD5(domstr); // "opendom_" + domstr.replace(/#/g, "_").replace(/\//g, "_").replace(/\?/g, "_").replace(/&/g, "_").replace(/\./g, "_")

            // if($("#"+id)&&$("#"+id).length)
            // {
            //     $("#"+id).remove();
            // }

            let obj = {
                id: id,
                type: 1,
                maxmin: false,
                title: title,
                area: area,
                content: $(domstr), //这里content是顶部引入的组件  注意type为1
                cancel: function(index, layero) {
                    layero;
                    layer.close(index);
                    // if (confirm('确定要关闭么'))
                    // { //只有当点击confirm框的确定时，该层才会关闭
                    //     layer.close(index)
                    // }
                    return false;
                },
                end: function() {
                    //J.Alert("销毁了");
                    $(domstr).hide();
                }
            }
            let newObj = Object.assign(obj, otherObj)
            layerObj = layer.open(newObj);
            //layer.full(layerObj);
            return layerObj;

        });
        return layerObj;
    },
    OpenHtmlStr: function(html, title, area, otherObj) {
        let layerObj = null;
        layui.use('layer', function() {
            var layer = layui.layer;

            let w = 'auto';
            let h = '500px';
            if (!area) {
                area = [w, h];
            } else {
                if (area[1] == "auto") {
                    area[1] = '500px';
                }
                if (parseInt(area[1].replace("px", "")) >= document.documentElement.clientHeight - 60 * 2) {
                    area[1] = '500px';
                }
            }
            if (parseInt(area[1].replace("px", "")) >= document.documentElement.clientHeight - 60 * 2) {
                area[1] = (document.documentElement.clientHeight - 60 * 2 - 10) * 1 + 'px';
            }


            let id = "openhtml_" + MD5(html); //"openhtml_" + title.replace(/\//g, "_").replace(/\?/g, "_").replace(/&/g, "_").replace(/\./g, "_")
            let obj = {
                id: id,
                type: 1,
                maxmin: false,
                title: title,
                area: area,
                content: html, //这里content是顶部引入的组件  注意type为1
                cancel: function(index, layero) {
                    layero;
                    layer.close(index);
                    // if (confirm('确定要关闭么'))
                    // { //只有当点击confirm框的确定时，该层才会关闭
                    //     layer.close(index)
                    // }
                    return false;
                },
                end: function() {
                    //J.Alert("销毁了");
                    //$(domstr).hide();
                }
            }
            let newObj = Object.assign(obj, otherObj)
            layerObj = layer.open(newObj);

            return layerObj;
            //layer.full(layerObj);
        });
        return layerObj;
    },

    OpenPage: function(url, title, area, otherObj) {
        let layerObj = null;
        layui.use('layer', function() {
            var layer = layui.layer;

            let w = 'auto';
            let h = '500px';
            if (!area) {
                area = [w, h];
            } else {
                if (area[1] == "auto") {
                    area[1] = '500px';
                }
                if (area[1].indexOf("%") >= 0) {
                    area[1] = '500px';
                }
                if (parseInt(area[1].replace("px", "")) >= document.documentElement.clientHeight - 60 * 2) {
                    area[1] = '500px';
                }
            }
            if (parseInt(area[1].replace("px", "")) >= document.documentElement.clientHeight - 60 * 2) {
                area[1] = (document.documentElement.clientHeight - 60 * 2 - 10) * 1 + 'px';
            }

            let id = "openpage_" + MD5(url); //"openpage_" + url.replace(/\//g, "_").replace(/\?/g, "_").replace(/&/g, "_").replace(/\./g, "_")
            let obj = {
                id: id,
                type: 2,
                maxmin: false,
                title: title,
                area: area,
                content: url, //这里content是顶部引入的组件  注意type为1
                cancel: function(index, layero) {
                    layero;
                    layer.close(index);
                    // if (confirm('确定要关闭么'))
                    // { //只有当点击confirm框的确定时，该层才会关闭
                    //     layer.close(index)
                    // }
                    return false;
                },
                end: function() {
                    //J.Alert("销毁了");

                }
            }
            let newObj = Object.assign(obj, otherObj)
            layerObj = layer.open(newObj);

            return layerObj;
            //layer.full(layerObj);
        });
        return layerObj;
    },
    Alert: (title, icon, toDo) => {

        if (!title || title == "undefined" || title == undefined || title == null || title == "null") {
            title = "网络不太顺畅，请稍候再试";
        }
        layui.use('layer', function() {
            var layer = layui.layer;


            if (!icon) {
                icon = -1;
            }
            if (!toDo) {
                toDo = function() {}
            }
            var lay1 = layer.alert(title, { icon: icon },
                function() {
                    toDo();
                    layer.close(lay1);
                }
            );

        });
    },
    Msg: (title, time, fun) => {
        if (!title || title == "undefined" || title == undefined || title == null || title == "null") {
            title = "网络不太顺畅，请稍候再试";
        }

        let tm = 2500;
        if (location.href.indexOf("chinasoftinc") >= 0) {
            tm = 5000;
        }
        layui.use('layer', function() {

            if (!time) {
                time = tm;
            }
            var layer = layui.layer;
            layer.msg(title, {
                icon: -1,
                shade: 0.3,
                shadeClose: false,
                time: time //1.2秒关闭（如果不配置，默认是3秒）
            }, function() {
                //do something
                if (typeof fun == "function")
                    fun();
            });
        });
    },
    Confirm: (content, title, toDo, cancelDo, btns) => {

        if (!content || content == "undefined" || content == undefined || content == null || content == "null") {
            content = "网络不太顺畅，请稍候再试";
        }

        if (!title) {
            title = "信息"
        }
        if (!toDo) {
            toDo = function() {}
        }
        if (!cancelDo) {
            cancelDo = function() {}
        }
        if (!btns) {
            btns = ['确定', '取消']
        }
        //询问框
        layui.use('layer', function() {
            var layer = layui.layer;

            var lay1 = layer.confirm(content, {
                btn: btns,
                icon: -1,
                title: title,
                closeBtn: false,
            }, function() {
                console.log("确定了");
                toDo();
                layer.close(lay1);
            }, function() {
                console.log("取消了");
                cancelDo();
            });

        });
    },
    Confirm1: (content, title, toDo, cancelDo, btns, icon) => {

        if (!content || content == "undefined" || content == undefined || content == null || content == "null") {
            content = "网络不太顺畅，请稍候再试";
        }

        if (!title) {
            title = "信息"
        }
        if (!toDo) {
            toDo = function() {}
        }
        if (!cancelDo) {
            cancelDo = function() {}
        }
        if (!btns) {
            btns = ['确定', '取消']
        }
        //询问框
        layui.use('layer', function() {
            var layer = layui.layer;

            var lay1 = layer.confirm(content, {
                btn: btns,
                icon: icon,
                title: title,
                closeBtn: 1,
            }, function() {
                console.log("确定了");
                toDo();
                layer.close(lay1);
            }, function() {
                console.log("取消了");
                cancelDo();
            });

        });
    },

    Loding: (msg) => {
        layui.use('layer', function() {
            var layer = layui.layer;
            if (!msg) {
                layer.load(2);
            } else {
                layer.msg(msg, {
                    icon: 16,
                    shadeClose: false,
                    shade: 0.01
                });
            }

        });
    },
    LodingHide: () => {
        layui.use('layer', function() {
            var layer = layui.layer;
            layer.closeAll('loading');
        });
    },


    ParseForm: function(layui_form) {
        var form = layui_form;
        var formon = form.on;
        form.on = function(events, callback, boxJqObj) {
            let that = this;
            let resObj;
            let selfName = "";
            if (boxJqObj && boxJqObj.length) {
                let filters = events.match(/\((.*)\)$/) || [] //提取事件过滤器字符结构，如：select(xxx)
                let filterName = filters[1] || '';
                let type = events.replace(filters[0], '');

                if (filterName == "") {
                    filterName = "_filter_" + new Date().getTime() + '_' + Math.floor(Math.random() * 100000);
                } else {
                    selfName = filterName.toString();
                    filterName += "_filter_selef_" + new Date().getTime() + '_' + Math.floor(Math.random() * 100000);
                }


                if (type == "select") {

                    filterName = "sel_" + filterName;
                    $(boxJqObj).find(type).each(function() {
                        if ($(this).attr('lay-filter') && $(this).attr('lay-filter').length) {
                            if ($(this).attr('lay-filter').indexOf("_filter_") >= 0) {
                                //自定义名称 需要保留原样 不能被覆盖 第一步  
                            }
                            if ($(this).attr('lay-filter') == selfName) {
                                //自定义名称 需要保留原样 不能被覆盖   第二步
                                $(this).attr('lay-filter', filterName);
                            }
                        } else {
                            $(this).attr('lay-filter', filterName);
                        }

                    });
                }

                //待完善    其他类型也应该跟select一样加上自定义名称逻辑
                if (type == "checkbox") {
                    filterName = "ck_" + filterName;
                    $(boxJqObj).find("input[type='checkbox']").each(function() {
                        //$(this).attr('lay-filter', filterName);

                        //console.log($(this));
                        if ($(this).attr('lay-skin') != "switch") {
                            if ($(this).attr('lay-filter') && $(this).attr('lay-filter').length) {
                                if ($(this).attr('lay-filter').indexOf("_filter_") >= 0) {
                                    //自定义名称 需要保留原样 不能被覆盖 第一步  
                                }
                                if ($(this).attr('lay-filter') == selfName) {
                                    //自定义名称 需要保留原样 不能被覆盖   第二步
                                    $(this).attr('lay-filter', filterName);
                                }
                            } else {
                                $(this).attr('lay-filter', filterName);
                            }

                        }

                    });
                }
                if (type == "radio") {
                    filterName = "ra_" + filterName;
                    $(boxJqObj).find(":radio").each(function() {
                        if ($(this).attr('lay-filter') && $(this).attr('lay-filter').length) {
                            if ($(this).attr('lay-filter').indexOf("_filter_") >= 0) {
                                //自定义名称 需要保留原样 不能被覆盖 第一步  
                            }
                            if ($(this).attr('lay-filter') == selfName) {
                                //自定义名称 需要保留原样 不能被覆盖   第二步
                                $(this).attr('lay-filter', filterName);
                            }
                        } else {
                            $(this).attr('lay-filter', filterName);
                        }
                    });
                }
                if (type == "switch") {
                    filterName = "sw_" + filterName;
                    $(boxJqObj).find(":checkbox").each(function() {
                        if ($(this).attr('lay-skin') == "switch") {
                            if ($(this).attr('lay-filter') && $(this).attr('lay-filter').length) {
                                if ($(this).attr('lay-filter').indexOf("_filter_") >= 0) {
                                    //自定义名称 需要保留原样 不能被覆盖 第一步  
                                }
                                if ($(this).attr('lay-filter') == selfName) {
                                    //自定义名称 需要保留原样 不能被覆盖   第二步
                                    $(this).attr('lay-filter', filterName);
                                }
                            } else {
                                $(this).attr('lay-filter', filterName);
                            }
                        }
                    });
                }
                if (type == "submit") {
                    filterName = "sub_" + filterName;
                    $(boxJqObj).find("submit,button,input[type='button'],input[type='submit']").each(function() {
                        if ($(this).attr('lay-filter') && $(this).attr('lay-filter').length) {
                            if ($(this).attr('lay-filter').indexOf("_filter_") >= 0) {
                                //自定义名称 需要保留原样 不能被覆盖 第一步  
                            }
                            if ($(this).attr('lay-filter') == selfName) {
                                //自定义名称 需要保留原样 不能被覆盖   第二步
                                $(this).attr('lay-filter', filterName);
                            }
                        } else {
                            $(this).attr('lay-filter', filterName);
                        }
                    });
                }

                let eventsNew = type + "(" + filterName + ")";
                resObj = formon.call(that, eventsNew, callback);
            } else {
                resObj = formon.call(that, events, callback);
            }
            return resObj;
        };



        return form;
    },
    ParseTree: function(oldTree, newTree, map = { id: "deptId", name: "deptName", pid: "parentDeptId", children: "children" }) {
        let newTree1 = newTree;
        for (var i = 0; i < oldTree.length; i++) {

            if (newTree1.length == 0) {
                newTree1 = {
                    id: -2,
                    title: "选择",
                    //*其他自定义参数
                    //*其他自定义参数
                    parent: -2,
                    spread: true,
                    children: [
                        //--------

                        //--------
                    ]
                }
            }

            var newrow = {
                id: oldTree[i].id || oldTree[i][map.id],
                title: oldTree[i].title || oldTree[i][map.name],
                //*其他自定义参数
                //*其他自定义参数
                parent: oldTree[i].parent || oldTree[i][map.pid],
                spread: oldTree[i].spread || oldTree[i][map.pid] == 0 ? true : false,
                //checked:oldTree[i].parentDeptId==0?true:false,
                children: [
                    //--------

                    //--------
                ]
            }
            if (!oldTree[i][map.children] || oldTree[i][map.children].length == 0) {

                newTree1.children.push(newrow);
            } else {
                common.ParseTree(oldTree[i][map.children], newrow, map);
                newTree1.children.push(newrow);
            }
        }

        return newTree1.children;
    },



    ParseTree2: function(oldTree, newTree, map = { id: "deptId", name: "deptName", pid: "parentDeptId", children: "children" }) {
        let newTree1 = newTree;
        for (var i = 0; i < oldTree.length; i++) {

            if (newTree1.length == 0) {
                newTree1 = {
                    id: -2,
                    label: "选择",
                    //*其他自定义参数
                    //*其他自定义参数
                    parent: -2,
                    spread: true,
                    children: [
                        //--------

                        //--------
                    ]
                }
            }

            var newrow = {
                id: oldTree[i].id || oldTree[i][map.id],
                label: oldTree[i].title || oldTree[i][map.name],
                //*其他自定义参数
                //*其他自定义参数
                isLeaf: false,
                parent: oldTree[i].parent || oldTree[i][map.pid],
                spread: oldTree[i].spread || oldTree[i][map.pid] == 0 ? true : false,
                //checked:oldTree[i].parentDeptId==0?true:false,
                children: [
                    //--------

                    //--------
                ]
            }
            if (oldTree[i].deptChildNodeNum == 0) {

                newrow.isLeaf = true;
            }

            if (!oldTree[i][map.children] || oldTree[i][map.children].length == 0) {

                newTree1.children.push(newrow);
            } else {
                newrow.isLeaf = false;
                common.ParseTree2(oldTree[i][map.children], newrow, map);

                newTree1.children.push(newrow);
            }
        }

        return newTree1.children;
    },

    SearchTree: function(oldTree, newTree, map = { id: "deptId", name: "deptName", pid: "parentDeptId", children: "children" }, title, key) {
        if (!map || map == "" || map == []) {
            map = { id: "deptId", name: "deptName", pid: "parentDeptId", children: "children" }
        }
        let newTree1 = newTree;
        if (!newTree1 || newTree1 == "" || newTree1 == []) {
            newTree1 = {
                id: -2,
                title: "选择",
                //*其他自定义参数
                //*其他自定义参数
                parent: -2,
                spread: true,
                children: [
                    //--------
                    //--------
                ]
            }
        }

        for (var i = 0; i < oldTree.length; i++) {
            let text = oldTree[i].title || oldTree[i][map.name];
            let title1 = title || "";
            title1 += "/" + text;
            var newrow = {
                id: oldTree[i].id || oldTree[i][map.id],
                title: ("//" + title1).replace("///", "").replace("//", ""),
                //*其他自定义参数
                //*其他自定义参数
                parent: oldTree[i].parent || oldTree[i][map.pid],
                spread: oldTree[i].spread || oldTree[i][map.pid] == 0 ? true : false,
                //checked:oldTree[i].parentDeptId==0?true:false,
                children: [
                    //--------
                    //--------
                ]
            }
            if (!oldTree[i][map.children] || oldTree[i][map.children].length == 0) {
                if (text.toLocaleLowerCase().indexOf(key.toLocaleLowerCase()) >= 0) {
                    newTree1.children.push(newrow);
                    //title1 = "";
                } else {

                }
            } else {
                if (text.toLocaleLowerCase().indexOf(key.toLocaleLowerCase()) >= 0) {
                    newTree1.children.push(newrow);
                    //title1 = "";
                } else {

                }
                common.SearchTree(oldTree[i][map.children], newTree1, map, title1, key);
            }


        }

        return newTree1.children;
    },


    Exit: () => {},
    Pms: {
        UserPms: [],
        Node: function(json, row, url) {
            if (common.Pms.UserPms.length > 0) {
                return
            }

            for (var i = 0; i < json.length; i++) {
                if (common.Pms.UserPms.length > 0) {
                    return
                }
                if (!json[i].url) {
                    continue;
                }
                if (url.toLocaleLowerCase().indexOf(json[i].url.toLocaleLowerCase()) >= 0) {
                    if (json[i].parentId != 0) {
                        common.Pms.UserPms = json[i].childsList;
                    }
                }
                var newrow = {
                    id: json[i].id,
                    name: json[i].menu_Name,
                    //*其他自定义参数
                    //*其他自定义参数
                    dom: json[i].domStr,
                    pid: json[i].parentId,
                    order: json[i].seq_No,
                    url: json[i].url,
                    ioc: json[i].ioc,
                    type: json[i].menu_Type,
                    isMust: json[i].isMust,
                    spread: false,
                    children: []
                }
                if (!json[i].childsList) {
                    row.children.push(newrow);
                } else {
                    common.Pms.Node(json[i].childsList, newrow, url);
                    row.children.push(newrow);
                }
            }
            //console.log(row);
        },
        GetPms: function() {
            var obj = {};
            try {
                var url = '';
                var pms = common.User.RolePms();
                if (url.indexOf("PageSet") >= 0) {
                    pms = []; //设置左侧通用 不按页面划分
                }
                var doc = {
                    name: "顶级",
                    spread: true,
                    children: []
                };
                //----获取当前页的权限数据------------
                common.Pms.UserPms = [];
                common.Pms.Node(pms, doc, url);
                var TreeJson = common.Pms.UserPms;
                //----------------------
                //console.log(TreeJson);
                for (var i = 0; i < TreeJson.length; i++) {
                    if (TreeJson[i].isHavePrivilege == 0 && TreeJson[i].domStr != "") {
                        if (TreeJson[i].domStr == "###") {
                            continue;
                        }
                        obj[TreeJson[i].domStr] = false;
                    } else if (TreeJson[i].isHavePrivilege == 1 && TreeJson[i].domStr != "") {
                        if (TreeJson[i].domStr == "###") {
                            continue;
                        }
                        obj[TreeJson[i].domStr] = true;
                    }
                    //alert(i);
                }
            } catch (error) {
                console.log(error);
            }
            //console.log(obj);
            return obj;
        },
    },
    //验证是否需要审批流程  approCom 公用选审批人组件
    checkFlowState: function(params, callback, approCom = { domId: "", area: [], isEmpLogin: false }, openIndex = 1) {
        //flowType, empId, deptId, positionLevelId,
        //sourceType: flowType,
        //empId: empId,
        //deptId: deptId,
        //positionLevelId: positionLevelId || "" 

        let url = API.commonApi.getFlowControlState;

        if (approCom.isEmpLogin) {
            url = url.replace("jhtml", "empweb");
        }

        common.Submit(url, JSON.stringify(params), function(res) {
            if (res.suc) {
                callback(res.result.data.examType, []);
                if (res.result.data.examType == Constant.APPROVAL_FLOW.OPTIONAL_APPROVAL) {
                    openIndex = common.OpenDom("#" + approCom.domId, "自选审批人", approCom.area);
                }
            } else {
                common.Msg(res.msg);
            }
        });
        return openIndex;
    },
    Request: {
        Url: function() {
            return location.href;
        },
        QueryWithUrl: function(url, name) {
            //var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
            //var r = window.location.search.substr(1).match(reg);
            //if (r != null) return unescape(r[2]); return "";
            var reg = new RegExp("[\?\&]" + name + "=([^\&]+)", "i");

            //debugger;
            //let search = url.substr(url.indexOf("?") + 1)
            var result = url.match(reg);
            if (result == null || result.length < 1) {
                return null;
            }
            return decodeURI(result[1]);
        },
        Query: function(name) {
            //var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
            //var r = window.location.search.substr(1).match(reg);
            //if (r != null) return unescape(r[2]); return "";
            var reg = new RegExp("[\?\&]" + name + "=([^\&]+)", "i");
            var result = location.search.match(reg);
            if (result == null || result.length < 1) {
                return null;
            }
            return decodeURI(result[1]);
        },
        HasQuery: function(url, name) {
            if (common.Request.QueryWithUrl(url, name) != null) {
                return true;
            }
            return false;
        },
        //queryList ---[{key:name,value:aaaa},{key:phone,value:111}]
        ParseUrl: function(url, queryList) {
            if (!queryList || queryList.length <= 0) {
                return url;
            }

            for (let index = 0; index < queryList.length; index++) {
                let q1 = queryList[index];
                if (common.Request.HasQuery(url, q1.key)) {
                    //如果URL本身带值  但是queryList也有值 则用queryList值覆盖初始值
                    let defVal = common.Request.QueryWithUrl(url, q1.key);
                    url = url.replace(q1.key + "=" + defVal, q1.key + "=" + q1.value);
                    continue;
                } else {
                    if (url.indexOf("?") >= 0) {
                        url += "&" + q1.key + "=" + q1.value;
                    } else {
                        url += "?" + q1.key + "=" + q1.value;
                    }
                }
            }
            return url;

        }
    },
    //常量
    Constant: Constant,
    //关闭弹框
    Cancel: function(that) {
        layui.use('layer', function() {
            let layer = layui.layer;
            layer.close(that.openIndex);
        });
    },
    GetMenu: function(call) {

 
        let cacheMenu = common.Data.Storage("sys_menus");
        if (!cacheMenu || cacheMenu == null || cacheMenu.length <= 0) {


            common.Submit(API.main.getAllAuMenusByToken, {}, function(res0) {
                if (res0.errorCode == Constant.RES_CODE.SUCCESS) { 
                        //获取菜单  组织菜单
                        let menus = res0.result.data;

                        common.Data.Storage("sys_menus", menus.sort(by('seq_No', by('id')))); 

                        call();
                } else {
                    call();
                }
            });
        } else {
            call();
        } 
    },

    GetSystem: function() {
        let url = location.href.toLocaleLowerCase();
        let sys = 1;
        let doc = {
                yi_hr: 1, //易HR管理端
                yi_emp: 2, //易HR员工端
                yi_notice: 3, //通知必达

                zr_hr: 5, //中软HR端
                zr_emp: 6, //中软员工端


                vt_hr: 7, //维他奶HR端
                vt_emp: 8 //维他奶员工端
            }
            //中软 --本地调试时  若需要判断到中软 则增加 || 条件命中到即可
        if (url.indexOf("chinasoftinc.com") >= 0) {
            if (url.indexOf("/personal/") >= 0) {
                sys = 6;
            } else {
                sys = 5;
            }
        } else if (url.indexOf("vitasoy-chn.com") >= 0) {
            if (url.indexOf("/personal/") >= 0) {
                sys = 8;
            } else {
                sys = 7;
            }
        } else if (url.indexOf(":12345") >= 0 || url.indexOf("notify.ctgpayroll.com") >= 0) {
            sys = 3;
        } else {

            if (url.indexOf("/personal/") >= 0) {
                sys = 2;
            } else {
                sys = 1;
            }

        }

        return {
            sys: sys,
            doc: doc
        }


    },
 
    //获取当前页面是不是有权限
    WhetherOrNotAuthorized(isUpdate, domStr) {
        let menuId = isUpdate == 1 ? common.Constant.EMP_DETAIL.UPDATE : common.Constant.EMP_DETAIL.VIEW;
        let isTrue = true;
        common.GetMenuById(menuId, (res) => {
            res.forEach((e) => {
                if (e.domStr == domStr && e.isHavePrivilege == 0) {
                    isTrue = false;
                }
            });
        });
        return isTrue;
    },
    //错误跳转页面
    ErrorDispose(_this) {
        location.href = "/#/authen/error/403?api=" + url;
    }, 
    GoBack(_this, times = 0, num = -1) {
        setTimeout(() => {
            window.history.length > 1 ?
                _this.$router.go(num) :
                _this.$router.push('/');
        }, times);

        let paths = common.Data.Storage("paths");
        paths.splice(0, 0 - num);
        common.Data.Storage("paths", paths);
    },
    JQuery(dom) {
        return $(dom);
    },
 
    isJSON(str) {
        if (typeof str == 'string') {
            try {
                var obj = JSON.parse(str);
                if (typeof obj == 'object' && obj) {
                    return true;
                } else {
                    return false;
                }

            } catch (e) {
                console.log('error：' + str + '!!!' + e);
                return false;
            }
        }
        console.log('It is not a string!')
    }, 
}
export default common;
